<template>
  <div class="container">
    <md-progress-bar md-mode="query" class="md-accent" v-if="loading"></md-progress-bar>
    
    <div class="md-layout-item md-size-100" v-else>
      <md-table md-card>
        <md-table-toolbar>
          <h1 class="md-title md-layout-item md-size-70">{{$t('editorial.list.title')}}</h1>
          <md-field class="md-layout-item md-size-25">
            <label>{{$t('editorial.list.filter')}}</label>
            <md-input v-model="filterLike"></md-input>
          </md-field>
        </md-table-toolbar>

        <md-table-row>
          <md-table-head>{{$t('editorial.list.title')}}</md-table-head>
          <md-table-head>{{$t('editorial.list.description')}}</md-table-head>
          <md-table-head>{{$t('editorial.list.publishDate')}}</md-table-head>
          <md-table-head>{{$t('editorial.list.edit')}}</md-table-head>
        </md-table-row>

        <md-table-row v-for="card in cards" :key="card.id">
          <md-table-cell>{{card.title}}</md-table-cell>
          <md-table-cell>{{card.description}}</md-table-cell>
          <md-table-cell>
            <badge :type="card.publishDate == null ? 'danger' : 'success'">
              {{card.publishDate == null ? "Sin publicar" : "Publicado" }}
            </badge>
          </md-table-cell>
          <md-table-cell>
              <md-button class="md-info" :to="`/editorial/${card.id}`">
              {{$t('editorial.list.edit')}}

              </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
      <pagination
        v-if="totalCards > 20"
        v-model="pageActual"
        :page-count="(totalCards / 20)">
    </pagination>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import moment from 'moment';
import {Pagination, Badge} from '@/components'

export default {
  components: {
    Pagination,
    Badge
  },
  data() {
    return {
      pageActual: 1,
      filterLike: '',
      loading: true
    }
  },
  computed: {
    ...mapState({
      cards: state => state.StuffModule.cards,
      totalCards: state => state.StuffModule.totalCards
    })
  },
  mounted() {
    this.search()
  },
  methods: {
    search(forceLoading = true) {
      if (forceLoading) this.loading = true
      this.$store.dispatch('editorialCardsSearch', {filter: this.filterLike, pageNumber: (this.pageActual - 1)})
        .then(() => {
          if(forceLoading) this.loading = false
        })
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm")
    },
  },
  watch: {
    pageActual() {
      this.search(false)
    },
    filterLike() {
      this.search(false)
    }
  }
}
</script>